import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { FullPageSpinner } from './Spinner';
import config from '../services/config';
import Auth from '../services/auth';

export function RedirectHome({ from }) {
  return (
    <Redirect
      to={{
        pathname: config.routes.home,
        state: { from }
      }}
    />
  );
}

export function AuthenticatedRoute({ user, render, location, ...rest }) {
  if (user.authenticated) {
    return <Route exact {...rest} render={render} />;
  }
  return (
    <Redirect
      to={{
        pathname: config.routes.signIn,
        state: { location }
      }}
    />
  );
}

export function Spin() {
  return <FullPageSpinner />;
}
export function SignIn() {
  useEffect(() => {
    Auth.signIn();
  });
  return <FullPageSpinner />;
}

export function SignInCallback({ user, location }) {
  if (user.authenticated) {
    return <RedirectHome from={location} />;
  }
  return <FullPageSpinner />;
}

export function SignOut() {
  useEffect(() => {
    Auth.signOut();
  });
  return <FullPageSpinner />;
}
